module.exports = __webpack_public_path__ + "img/logo.ae286053.svg";